import TextMacroManager from 'pages/ScribeDashboard/RightPanel';
import React, { useEffect, useState } from 'react';

const TextMacros = () => {
  const [data, setData] = useState<any>(null);
  const [isTextMacroLoading, setIsTextMacroLoading] = useState(false);
  const [textMacros, setTextMacros] = useState<any[]>([]);

  const userRolesData = localStorage.getItem('roles') || '';
  const userData = userRolesData ? JSON.parse(userRolesData) : null;
  const userId = userData?.id;
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsTextMacroLoading(true);
        const token = localStorage.getItem('AUTH_TOKEN');
        const response = await fetch(
          `${baseUrl}/api/textmacros?userid=${userId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error('Network response was not ok');
        const responseData = await response.json();
        setData(responseData);
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
      } finally {
        setIsTextMacroLoading(false);
      }
    };

    fetchData();
  }, [baseUrl, userId]);

  useEffect(() => {
    if (data) {
      setTextMacros(data);
    }
  }, [data]);

  return (
    <TextMacroManager
      textMacros={textMacros || []}
      setTextMacros={setTextMacros}
      isTextMacroLoading={isTextMacroLoading}
    />
  );
};

export default TextMacros;
